import Car1 from './assets/car1.png'
import Car2 from './assets/car2.png'
import Car3 from './assets/car3.png'
import Sho1 from './assets/else/Accumulator.jpg'
import Sho2 from './assets/else/bearings.jpg'
import Sho3 from './assets/else/brakes.jpg'
import Sho4 from './assets/else/engine.jpg'
import Sho5 from './assets/else/spring.jpg'
import Sho6 from './assets/else/steer.jpg'
import Sho7 from './assets/else/tires.png'
import Tel1 from './assets/else/Tel1.jpeg'
import Tel2 from './assets/else/Tel2.jpeg'
import Tel3 from './assets/else/Tel3.jpeg'


export const sliderItems = [
    {
      id: 1,
      img: Car1,
      title: "BORN TO PERFORM",
      desc: "SPRING SALES! GET FLAT 40% OFF.",
      bg: "d1d1d1",
    },
    {
      id: 2,
      img: Car2,
      title: "DRIVE YOUR DEARMS",
      desc: "CALL TODAY AND GET IN LINE! GET FLAT 40% OFF.",
      bg: "c9c9c9",
    },
    {
      id: 3,
      img: Car3,
      title: "THE ROAD WILL NEVER BE THE SAME",
      desc: "TODAY! GET FLAT 50% OFF FOR NEW ARRIVALS.",
      bg: "d1d1d1",
    },
  ];

  export const categories = [
    {
      id: 1,
      img: Tel1,
      title: "THERE IS NO SUBSTITUTE",
    },
    {
      id: 2,
      img: Tel2,
      title: "THE ART OF PERFORMANCE",
    },
    {
      id: 3,
      img: Tel3,
      title: "THE POWER OF DREAMS",
    },
  ];

  export const popularProducts = [
    {
      id:1,
      img:Sho1,
      desc:"Lorem ipsum dolor sit amet consectetur adipisicing elit. Molestiae nostrum tempora architecto quasi quae ipsam, id impedit optio itaque explicabo, rem vero. Veritatis quibusdam provident vitae dicta pariatur rem quis debitis? Adipisci nisi et obcaecati, deserunt repellendus provident est modi, placeat ipsum quae impedit minus delectus quos ipsam maiores pariatur nihil corrupti reiciendis voluptatem, at odio. Quos sit, soluta perspiciatis autem quasi delectus vitae iste aliquid ea voluptatibus illum earum numquam, debitis, laboriosam nesciunt nisi molestiae eaque placeat consequatur dicta quae? Iure ab repudiandae dolorem eos vel amet libero, ipsa commodi qui tempore modi. Dolor enim quasi sint aspernatur deserunt."
    },
    {
      id:2,
      img:Sho2,
      desc:"Lorem ipsum dolor sit amet consectetur adipisicing elit. Molestiae nostrum tempora architecto quasi quae ipsam, id impedit optio itaque explicabo, rem vero. Veritatis quibusdam provident vitae dicta pariatur rem quis debitis? Adipisci nisi et obcaecati, deserunt repellendus provident est modi, placeat ipsum quae impedit minus delectus quos ipsam maiores pariatur nihil corrupti reiciendis voluptatem, at odio. Quos sit, soluta perspiciatis autem quasi delectus vitae iste aliquid ea voluptatibus illum earum numquam, debitis, laboriosam nesciunt nisi molestiae eaque placeat consequatur dicta quae? Iure ab repudiandae dolorem eos vel amet libero, ipsa commodi qui tempore modi. Dolor enim quasi sint aspernatur deserunt."
    },
    {
      id:3,
      img:Sho3,
      desc:"Lorem ipsum dolor sit amet consectetur adipisicing elit. Molestiae nostrum tempora architecto quasi quae ipsam, id impedit optio itaque explicabo, rem vero. Veritatis quibusdam provident vitae dicta pariatur rem quis debitis? Adipisci nisi et obcaecati, deserunt repellendus provident est modi, placeat ipsum quae impedit minus delectus quos ipsam maiores pariatur nihil corrupti reiciendis voluptatem, at odio. Quos sit, soluta perspiciatis autem quasi delectus vitae iste aliquid ea voluptatibus illum earum numquam, debitis, laboriosam nesciunt nisi molestiae eaque placeat consequatur dicta quae? Iure ab repudiandae dolorem eos vel amet libero, ipsa commodi qui tempore modi. Dolor enim quasi sint aspernatur deserunt."
    },
    {
      id:4,
      img:Sho4,
      desc:"Lorem ipsum dolor sit amet consectetur adipisicing elit. Molestiae nostrum tempora architecto quasi quae ipsam, id impedit optio itaque explicabo, rem vero. Veritatis quibusdam provident vitae dicta pariatur rem quis debitis? Adipisci nisi et obcaecati, deserunt repellendus provident est modi, placeat ipsum quae impedit minus delectus quos ipsam maiores pariatur nihil corrupti reiciendis voluptatem, at odio. Quos sit, soluta perspiciatis autem quasi delectus vitae iste aliquid ea voluptatibus illum earum numquam, debitis, laboriosam nesciunt nisi molestiae eaque placeat consequatur dicta quae? Iure ab repudiandae dolorem eos vel amet libero, ipsa commodi qui tempore modi. Dolor enim quasi sint aspernatur deserunt."
    },
    {
      id:5,
      img:Sho5,
      desc:"Lorem ipsum dolor sit amet consectetur adipisicing elit. Molestiae nostrum tempora architecto quasi quae ipsam, id impedit optio itaque explicabo, rem vero. Veritatis quibusdam provident vitae dicta pariatur rem quis debitis? Adipisci nisi et obcaecati, deserunt repellendus provident est modi, placeat ipsum quae impedit minus delectus quos ipsam maiores pariatur nihil corrupti reiciendis voluptatem, at odio. Quos sit, soluta perspiciatis autem quasi delectus vitae iste aliquid ea voluptatibus illum earum numquam, debitis, laboriosam nesciunt nisi molestiae eaque placeat consequatur dicta quae? Iure ab repudiandae dolorem eos vel amet libero, ipsa commodi qui tempore modi. Dolor enim quasi sint aspernatur deserunt."
    },
    {
      id:6,
      img:Sho6,
      desc:"Lorem ipsum dolor sit amet consectetur adipisicing elit. Molestiae nostrum tempora architecto quasi quae ipsam, id impedit optio itaque explicabo, rem vero. Veritatis quibusdam provident vitae dicta pariatur rem quis debitis? Adipisci nisi et obcaecati, deserunt repellendus provident est modi, placeat ipsum quae impedit minus delectus quos ipsam maiores pariatur nihil corrupti reiciendis voluptatem, at odio. Quos sit, soluta perspiciatis autem quasi delectus vitae iste aliquid ea voluptatibus illum earum numquam, debitis, laboriosam nesciunt nisi molestiae eaque placeat consequatur dicta quae? Iure ab repudiandae dolorem eos vel amet libero, ipsa commodi qui tempore modi. Dolor enim quasi sint aspernatur deserunt."
    },
    {
      id:7,
      img:Sho7,
      desc:"Lorem ipsum dolor sit amet consectetur adipisicing elit. Molestiae nostrum tempora architecto quasi quae ipsam, id impedit optio itaque explicabo, rem vero. Veritatis quibusdam provident vitae dicta pariatur rem quis debitis? Adipisci nisi et obcaecati, deserunt repellendus provident est modi, placeat ipsum quae impedit minus delectus quos ipsam maiores pariatur nihil corrupti reiciendis voluptatem, at odio. Quos sit, soluta perspiciatis autem quasi delectus vitae iste aliquid ea voluptatibus illum earum numquam, debitis, laboriosam nesciunt nisi molestiae eaque placeat consequatur dicta quae? Iure ab repudiandae dolorem eos vel amet libero, ipsa commodi qui tempore modi. Dolor enim quasi sint aspernatur deserunt."
    },
    {
      id:8,
      img:Sho1,
      desc:"Lorem ipsum dolor sit amet consectetur adipisicing elit. Molestiae nostrum tempora architecto quasi quae ipsam, id impedit optio itaque explicabo, rem vero. Veritatis quibusdam provident vitae dicta pariatur rem quis debitis? Adipisci nisi et obcaecati, deserunt repellendus provident est modi, placeat ipsum quae impedit minus delectus quos ipsam maiores pariatur nihil corrupti reiciendis voluptatem, at odio. Quos sit, soluta perspiciatis autem quasi delectus vitae iste aliquid ea voluptatibus illum earum numquam, debitis, laboriosam nesciunt nisi molestiae eaque placeat consequatur dicta quae? Iure ab repudiandae dolorem eos vel amet libero, ipsa commodi qui tempore modi. Dolor enim quasi sint aspernatur deserunt."
    },
  ]